import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { LOGIN_WITH_GOOGLE_ID_TOKEN_MUTATION } from '../graphql/mutations'
import { LOGIN } from '../redux/action-types'

const useLoginMutation = () => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(store => store.account.login)

  const mutate = useCallback(
    googleIdToken =>
      apolloService.mutate({
        mutation: LOGIN_WITH_GOOGLE_ID_TOKEN_MUTATION,
        variables: { googleIdToken },
        dispatch,
        action: LOGIN,
      }),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useLoginMutation
